export default __webpack_public_path__ + "static/about-logo-01-79b39acc2b2868b8f7197bf61ebf1ce3.png";